import { FC } from "react";

import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { MeasurementSystem } from "src/js/stores/user/store";

import { PerAreaPriceModes } from "../../../typings";
import { Item } from "./Item";

export function hasInsufficientData(data?: number[] | null) {
  return (data || []).reduce((acc, number) => acc.add(number), new Set()).size <= 2;
}

export interface PricePerAreaProps {
  priceMode: PerAreaPriceModes;
  loading: boolean;
  distribution?: number[] | null;
  unitType: MeasurementSystem;
}
export const PricePerArea: FC<PricePerAreaProps> = ({
  priceMode,
  distribution,
  loading,
  unitType,
}) => {
  const { t } = useTranslation();

  if (!loading && hasInsufficientData(distribution)) {
    return (
      <div className="atlas-flex atlas-flex-col atlas-items-stretch" data-testid="price-per-area">
        <Item loading={false} index={0} unitType={unitType} />
        <span className="atlas-p-2">{t("comparables.map.legend.insufficient_data")}</span>
      </div>
    );
  }

  return (
    <div className="atlas-flex atlas-flex-col atlas-items-stretch" data-testid="price-per-area">
      <span className="atlas-m-2">
        <span className="atlas-font-semibold atlas-pr-1">
          {t("comparables.map.legend.pppa_unit", {
            unitType:
              unitType === MeasurementSystem.METRIC
                ? t("units.distance.short.metric")
                : t("units.distance.short.imperial"),
            currency: t("units.currency.default_currency"),
          })}
        </span>
        <span className="atlas-font-semibold atlas-pr-1">
          {priceMode === PerAreaPriceModes.PPSM
            ? t("comparables.map.legend.price")
            : t("comparables.map.legend.est_price")}
        </span>
        -
        <span className="atlas-pl-1">
          {priceMode === PerAreaPriceModes.PPSM
            ? t("comparables.map.legend.price_paid")
            : t("comparables.map.legend.estimated_market_value")}
        </span>
      </span>
      <span className="atlas-flex atlas-flex-col">
        {[0, 1, 2, 3, 4, 5].map((e) => (
          <Item
            loading={!distribution}
            price={distribution?.[e] ?? 0}
            index={e}
            unitType={unitType}
            key={"item-" + e}
          />
        ))}
      </span>
    </div>
  );
};
